export class WebGlUtils {
	public static WEBGL_compressed_texture_s3tc = "WEBGL_compressed_texture_s3tc";
	public static OES_texture_float_linear = "OES_texture_float_linear";
	public static WEBGL_draw_buffers = "WEBGL_draw_buffers";

	private static _instance?: WebGlUtils;

	private _supportedWebGLExtensions: string[];

	private constructor(private autodeskMapId: string) {
		this._supportedWebGLExtensions = this.getSupportedWebGLExtensions();
	}

	public static instance(autodeskMapId: string): WebGlUtils {
		if (WebGlUtils._instance == null) {
			WebGlUtils._instance = new WebGlUtils(autodeskMapId);
		}

		return WebGlUtils._instance;
	}

	public get supportedWebGLExtensions(): string[] {
		return this._supportedWebGLExtensions;
	}

	public hasExtensions(...extensions: string[]): boolean {
		return extensions.every((extension) => this._supportedWebGLExtensions.some((s) => s === extension));
	}

	private getSupportedWebGLExtensions(): string[] {
		// https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext
		const canvas = document.querySelectorAll(`#${this.autodeskMapId} canvas`);

		if (canvas.length > 0) {
			const gl = (canvas[0] as HTMLCanvasElement).getContext("webgl2");

			// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Using_Extensions
			return gl?.getSupportedExtensions() ?? [];
		}
		return [];
	}
}
